import * as React from "react";
import { forwardRef } from "react";
const SvgPurchaseReturns = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-square-arrow-up", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 18, height: 18, x: 3, y: 3, rx: 2 }), /* @__PURE__ */ React.createElement("path", { d: "m16 12-4-4-4 4" }), /* @__PURE__ */ React.createElement("path", { d: "M12 16V8" }));
const ForwardRef = forwardRef(SvgPurchaseReturns);
export { ForwardRef as ReactComponent };
